

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import IslandBadge from './IslandBadge.vue';
import { Getter } from 'vuex-class';
import { AvailableTriggers, FlowViewModel, TriggerType } from '@/features/bots/models/designer';
import { ConditionGroupViewModel } from '@/shared/components/conditions/models/conditionGroupViewModel';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import EditIntentModal from '@/features/bots/components/designer/EditIntentModal.vue';
import { ParentViewModel } from '@/features/bots/models/parentViewModel';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import { TransitionType } from '@/features/bots/models/designer/transitionType';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import { TriggerItem } from '@/features/bots/models/designer/triggerType';
import { TriggerConditionAttributeType } from './Conditions/triggerConditionsManager';
import { ConditionGroup } from '@/shared/components/conditions/models/conditionGroup';
import { UsageLimitType } from '@/features/settings/models/usageLimitType';
import AlertOutline from 'vue-material-design-icons/AlertOutline.vue';

@Component({
	components: {
		EditIntentModal,
		IslandBadge,
		TransitionPicker,
		EditIcon,
		AlertOutline: AlertOutline as any
	}
})
export default class Triggers extends Vue {
	@Prop() public conditions: ConditionGroupViewModel;
	@Getter public parentFlows!: ParentViewModel[];
	@Getter public parentAnswers!: ParentViewModel[];
	@Getter public currentFlow!: FlowViewModel;
	@Getter public isCurrentFlowTriggerable!: boolean;
	@Getter public getIntentName!: (intentId: string) => string;
	@Getter public workspaceUsageLimit!: (usageLimitType: string) => number;
	public intentToEdit: string = '';

	public getFlowTransition(flow: ParentViewModel) {
		return {
			payload: flow.id,
			type: TransitionType.Flow
		} as TransitionViewModel;
	}

	public getAnswerTransition(answer: ParentViewModel) {
		return {
			payload: answer.id,
			type: TransitionType.Answer
		} as TransitionViewModel;
	}

	public getSelectedTriggerDescription(type: string) {
		const selected = AvailableTriggers.get(type);
		if (selected) {
			if (selected.type === TriggerType.MessageReceived && this.conditions) {
				return this.getDescriptionForMessageReceived(selected);
			}
			return selected.description;
		}
	}

	public getIconName(iconKey: string) {
		return AvailableTriggers.get(iconKey).icon;
	}

	public editIntent(trigger: string) {
		const intent = this.getIntentCondition(trigger);
		if (intent) {
			this.intentToEdit = intent.value;
			this.$nextTick(() => {
				const modal: any = this.$refs.editIntentModal;
				if (modal) {
					modal.showModal();
				}
			});
		}
	}

	public isValidIntentSelected(trigger: string) {
		const intentCondition = this.getIntentCondition(trigger);
		return !!intentCondition && !!this.getIntentName(intentCondition.value);
	}

	public shouldDisplayProactiveTriggerMessage() {
		return this.proactiveTriggerLimit === 0 && this.currentFlow.triggers.some((trigger: string) => {
			return trigger === TriggerType.WidgetLoaded;
		});
	}

	private getIntentCondition(trigger: string) {
		const selected = AvailableTriggers.get(trigger);
		if (selected) {
			if (selected.type === TriggerType.MessageReceived && this.conditions) {
				return ConditionGroup.find(this.conditions, c => c.attribute === TriggerConditionAttributeType.MessageIntent && c.value.length > 0);
			}
		}
	}

	private getDescriptionForMessageReceived(selected: TriggerItem) {
		let output = '';
		const conditions = ConditionGroup.findAll(this.conditions,
			c => (c.attribute === TriggerConditionAttributeType.MessageText || c.attribute === TriggerConditionAttributeType.MessageIntent)  && c.value.length > 0);
		for (const condition of conditions) {
			if (condition.type === 'intent') {
				output += ` ${this.getIntentName(condition.value) || condition.value}`;
			} else {
				output += ` ${condition.value}`;
			}
		}
		return output ? output : selected.description;
	}

	private get proactiveTriggerLimit(): number {
		return this.workspaceUsageLimit(UsageLimitType.ProactiveTriggers);
	}

}
